module.exports = __webpack_public_path__ + "static/media/ImageSearch_12.fc0165a2.webp";